import { Box, Typography } from "@mui/material";
import { Option } from "common/modules/helpers";
import moment from "moment";
import React from "react";

interface DataFieldProps {
  id?: string;
  label?: string;
  value?: string | number | any[] | boolean | null;
  type?: string | "number" | "date" | "dateTime" | "boolean";
  multiline?: boolean;
  children?: React.ReactNode;
  colorValue?: string;
  isLast?: boolean;
  hideEmptyValue?: boolean;
  options?: Option[];
  renderValue?: (value: any) => React.ReactNode;
}

export const DataField: React.FC<DataFieldProps> = ({
  label,
  value,
  children,
  colorValue,
  isLast = false,
  renderValue,
  options,
  hideEmptyValue,
  type,
  multiline,
}) => {
  let displayValue: React.ReactNode;

  if (renderValue) {
    displayValue = renderValue(value);
  } else if (type === "boolean") {
    displayValue = value ? "Igen" : "Nem";
  } else if (type === "date" && value) {
    const date = moment(value as string);
    displayValue = date.format("L");
  } else if (type === "dateTime" && value) {
    const date = moment(value as string);
    displayValue = date.format("L LT");
  } else if (type === "number" && value !== null && value !== undefined) {
    displayValue = Number(value).toLocaleString("hu-HU");
  } else if (Array.isArray(value)) {
    displayValue = value.join(", ");
  } else if (options && options.length > 0) {
    const matchingOption = options.find(
      option => String(option.value) === String(value),
    );
    displayValue = matchingOption ? matchingOption.label : children || value;
  } else {
    displayValue = children || value;
  }

  if (
    hideEmptyValue &&
    (value === null || value === undefined || value === "")
  ) {
    return null;
  }

  return (
    <Box
      display="flex"
      alignItems={multiline ? "flex-start" : "center"}
      justifyContent="space-between"
      sx={{
        borderBottom: isLast ? "none" : "1px solid #ddd",
        pt: 0.5,
        minHeight: 40,
        gap: 1,
      }}
    >
      <Box flex="0 0 33%">
        <Typography variant="body2" fontWeight="bold">
          {label}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
        {colorValue && (
          <Box
            sx={{
              display: "inline-block",
              width: 12,
              height: 12,
              borderRadius: 0.75,
              backgroundColor: colorValue,
            }}
          />
        )}
        {displayValue ? (
          <Typography
            variant="body2"
            component="div"
            sx={{
              textAlign: "right",
              whiteSpace: multiline ? "pre-wrap" : "normal",
            }}
          >
            {displayValue}
          </Typography>
        ) : (
          <Typography
            variant="body2"
            component="div"
            sx={{
              color: "#bbb",
              fontStyle: "italic",
              textAlign: "right",
            }}
          >
            nincs adat
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default DataField;
